import React, { Fragment } from 'react';
import { Button, Image } from '../../../../commonComponents';
import './SelectedPanel.scss';

const SelectedPanel = ({
  className,
  btnDisabled,
  onButtonClick,
  displaySelection,
  image,
}) => {
  const containerClass = 'quiz-item quiz-item__next next-' + className;
  const imageClass = 'quiz-item-selected-' + className;
  return (
    <Fragment>
      <section className={containerClass}>
        <Button
          disabled={btnDisabled}
          onClick={onButtonClick}
          defaultMessage="Next"
          value="dba.next"
          classNameValue="quiz-item--next-btn"
        />
      </section>
      <section className={imageClass}>
        {displaySelection && (
          <Image className="img-responsive" src={image} alt="" />
        )}
      </section>
    </Fragment>
  );
};

export default SelectedPanel;
